module.exports = __webpack_public_path__ + "img/SEARCH.e48cff17.svg";